/**
 * Enum defining the various SignalR target events.
 *
 * @enum {string}
 * @readonly
 */
export enum SignalrTargetsEnum {
  onRepresentativeChange = 'onRepresentativeChange',
  onJwtChange = 'onJwtChange',
}
